module.exports = __webpack_public_path__ + "img/colored-rounded.d8e2822a.svg";